import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import React, { useEffect, Fragment, useState } from "react";

import { useAxios } from "../../../../hooks";
import { Autocomplete } from "../../../../components";
import { HeadingEighteen } from "../../../css components/Style";

export default function FormEighth({
  agentToken,
  setAgentToken,
  agents,
  formikProps,
  editState,
}) {
  const [templateDetails, setTemplateDetails] = useState([]);

  const { accessToken, enabledChannels } = useSelector(
    (state) => state.memberDetails
  );

  const axios = useAxios({
    baseURL: "cpass_api",
    customAuthToken: "Bearer " + accessToken,
  });

  useEffect(() => {
    if (
      formikProps.values?.whatsapp_agent?.value &&
      formikProps.values?.whatsapp_template?.value
    ) {
      axios({
        url:
          "/bot/bot-template-details/" +
          formikProps.values?.whatsapp_agent?.value,
        method: "GET",
        disableRedirect: true,
      }).then((response) => {
        if (response.status) {
          setTemplateDetails(response.data);
        }
      });
    }
  }, [axios, agents?.Whatsapp]);

  function handleChangeAgent(value, type, name, primaryKey) {
    if (type === "selectOption") {
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: {
          value: value[primaryKey],
        },
      }));
      setAgentToken((prev) => ({
        ...prev,
        [name]: value.access_token,
      }));

      if (name === "whatsapp_agent") {
        axios({
          url: "/bot/bot-template-details/" + value.agent_id,
          method: "GET",
          disableRedirect: true,
        }).then((response) => {
          if (response.status) {
            setTemplateDetails(response.data);
          }
        });
      }
    } else {
      value = {
        value: "",
        label: "",
      };
      formikProps.setValues((prevVal) => ({
        ...prevVal,
        [name]: {
          value: value.label,
        },
      }));
      setAgentToken((prev) => ({
        ...prev,
        [name]: value.value,
      }));
      setTemplateDetails("");
    }
  }

  return (
    <Fragment>
      {formikProps.values?.pref_campaign_channel?.value?.length !== 0 &&
        formikProps.values.pref_campaign_channel.value.includes(1) &&
        enabledChannels?.is_whatsapp_enabled && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Whatsapp Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                label={"WhatsApp Agent Details"}
                forcePopupIcon={!editState ? false : true}
                name="whatsapp_agent.value"
                placeholder="WhatsApp Agent Details"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={agents["Whatsapp"]}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "whatsapp_agent", "agent_id")
                }
                formikProps={formikProps}
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                label="WhatsApp Template Details"
                forcePopupIcon={!editState ? false : true}
                name="whatsapp_template.value"
                placeholder="WhatsApp Template Details"
                defaults={{
                  primaryKey: "_id",
                  displayLabel: "name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={templateDetails}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "whatsapp_template", "_id")
                }
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}

      {formikProps.values?.pref_campaign_channel?.value?.length !== 0 &&
        formikProps.values.pref_campaign_channel.value.includes(3) && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Meta Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                label={"Meta Agent Details"}
                forcePopupIcon={!editState ? false : true}
                name="meta_agent_id.value"
                placeholder="Meta Agent Details"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={agents["Facebook"] || []}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "meta_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}

      {formikProps.values?.pref_campaign_channel?.value?.length !== 0 &&
        formikProps.values.pref_campaign_channel.value.includes(5) && (
          <Fragment>
            <Grid item xs={12}>
              <HeadingEighteen>Google Agent Details</HeadingEighteen>
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                label={"Google Agent Details"}
                forcePopupIcon={!editState ? false : true}
                name="google_agent_id.value"
                placeholder="Google Agent Details"
                defaults={{
                  primaryKey: "agent_id",
                  displayLabel: "agent_name",
                }}
                sx={{
                  "& .MuiSvgIcon-root": {
                    display: !editState && "none",
                  },
                }}
                options={agents["Google Ads"] || []}
                disabled={!editState}
                onChange={(_, value, type) =>
                  handleChangeAgent(value, type, "google_agent_id", "agent_id")
                }
                formikProps={formikProps}
              />
            </Grid>
          </Fragment>
        )}
    </Fragment>
  );
}
